/*
 * bpmbuild-uat-ds.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/Choice', 'model/Choices', 'model/FieldsBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./Choice'), require('./Choices'), require('./FieldsBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildUatDsappspotcom) {
      root.BpmbuildUatDsappspotcom = {};
    }
    root.BpmbuildUatDsappspotcom.AnswerBean = factory(root.BpmbuildUatDsappspotcom.ApiClient, root.BpmbuildUatDsappspotcom.Choice, root.BpmbuildUatDsappspotcom.Choices, root.BpmbuildUatDsappspotcom.FieldsBean);
  }
}(this, function(ApiClient, Choice, Choices, FieldsBean) {
  'use strict';

  /**
   * The AnswerBean model module.
   * @module model/AnswerBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>AnswerBean</code>.
   * @alias module:model/AnswerBean
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>AnswerBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AnswerBean} obj Optional instance to populate.
   * @return {module:model/AnswerBean} The populated <code>AnswerBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('boolean'))
        obj._boolean = ApiClient.convertToType(data['boolean'], 'Boolean');
      if (data.hasOwnProperty('choice'))
        obj.choice = Choice.constructFromObject(data['choice']);
      if (data.hasOwnProperty('choices'))
        obj.choices = Choices.constructFromObject(data['choices']);
      if (data.hasOwnProperty('date'))
        obj._date = ApiClient.convertToType(data['date'], 'String');
      if (data.hasOwnProperty('email'))
        obj.email = ApiClient.convertToType(data['email'], 'String');
      if (data.hasOwnProperty('field'))
        obj.field = FieldsBean.constructFromObject(data['field']);
      if (data.hasOwnProperty('fileUrl'))
        obj.fileUrl = ApiClient.convertToType(data['fileUrl'], 'String');
      if (data.hasOwnProperty('number'))
        obj._number = ApiClient.convertToType(data['number'], 'Number');
      if (data.hasOwnProperty('payment'))
        obj.payment = ApiClient.convertToType(data['payment'], 'String');
      if (data.hasOwnProperty('phone_number'))
        obj.phoneNumber = ApiClient.convertToType(data['phone_number'], 'String');
      if (data.hasOwnProperty('text'))
        obj.text = ApiClient.convertToType(data['text'], 'String');
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
    }
    return obj;
  }

  /**
   * @member {Boolean} _boolean
   */
  exports.prototype._boolean = undefined;

  /**
   * @member {module:model/Choice} choice
   */
  exports.prototype.choice = undefined;

  /**
   * @member {module:model/Choices} choices
   */
  exports.prototype.choices = undefined;

  /**
   * @member {String} _date
   */
  exports.prototype._date = undefined;

  /**
   * @member {String} email
   */
  exports.prototype.email = undefined;

  /**
   * @member {module:model/FieldsBean} field
   */
  exports.prototype.field = undefined;

  /**
   * @member {String} fileUrl
   */
  exports.prototype.fileUrl = undefined;

  /**
   * @member {Number} _number
   */
  exports.prototype._number = undefined;

  /**
   * @member {String} payment
   */
  exports.prototype.payment = undefined;

  /**
   * @member {String} phoneNumber
   */
  exports.prototype.phoneNumber = undefined;

  /**
   * @member {String} text
   */
  exports.prototype.text = undefined;

  /**
   * @member {String} type
   */
  exports.prototype.type = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsUatds/src/model/AnswerBean.js